import { Swiper } from "swiper";
import {
  Autoplay,
  Grid,
  Navigation,
  Pagination,
} from "swiper/modules";

export {
  Autoplay,
  Grid,
  Navigation,
  Pagination,
  Swiper,
};
